import PropTypes from 'prop-types'
import {
  StyledDialog,
  StyledDialogContent,
  StyledDialogTitle,
  StyledDisagreeButton,
  StyledActionButton,
  StyledNote,
  StyledCustomDialogActions
} from './UserFeedbackDashboardStyle'

const ParticipantConsentDialog = ({open, onClose, onConfirm}) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledDialogTitle>Participant Consent</StyledDialogTitle>
      <StyledDialogContent>
        <p>
          Deloitte would like to collect information about how you use this application, for example, the features in
          the application you click, how you navigate around the application, and time spent on different features, to
          improve and enhance the application. This information will be associated to the Persona you select but will
          not otherwise be identifiable to you.
        </p>
        <StyledNote>
          By clicking &quot;I Agree&quot;, you consent to Deloitte&apos;s collection and use of this information.
        </StyledNote>
      </StyledDialogContent>
      <StyledCustomDialogActions>
        <StyledActionButton onClick={onConfirm} variant='contained' color='primary'>
          Agree
        </StyledActionButton>
        <StyledDisagreeButton onClick={onClose} variant='outlined'>
          Disagree
        </StyledDisagreeButton>
      </StyledCustomDialogActions>
    </StyledDialog>
  )
}

ParticipantConsentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ParticipantConsentDialog
